import { AnalyticsStore, RouteStore } from 'bernie-core';

export const showTerms = (event, analytics: AnalyticsStore, eventMetadata: string) => {
  const routeStore: RouteStore = event;
  if (routeStore && routeStore.updateSearch) {
    routeStore.updateSearch({ pwaDialog: 'couponTerms' });
  }
};
